import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescriptionItemsServiceComponent } from '../description/items-service/description-items-service.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-tooltip',
  standalone: true,
  imports: [CommonModule, DescriptionItemsServiceComponent],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  openTooltip = input.required<boolean>();
  closeTooltip = output<boolean>();

  subtitleColor = input<string>('medium-blue');

  title = input.required();
  description = input();
  label = input();

  buttonPosition = input();

  dialogClose() {
    this.closeTooltip.emit(false);
  }
}
